export default __webpack_public_path__ + "static/media/OpenSea-Full-Logo (light) 1.fdf5108c.svg";